import { ConversationStore, Tokens, getDefaultClientAIContentUrl, getDefaultClientAIStreamUrl, } from '@mcn-platform/converse-lib';
/**
 * Adapter to make a PortalStore conform to the IConversationStore interface.
 */
export default class ConversationStoreAdapter {
    constructor(portalStore) {
        this.portalStore = portalStore;
        this.conversationStore = ConversationStore.create({
            portalStore,
        });
    }
    get currentPortalID() {
        return this.portalStore.currentPortal?.id ?? '';
    }
    get currentOrganizationID() {
        return this.portalStore.currentOrganization?.id ?? '';
    }
    get amplifyEnvironment() {
        return this.portalStore.amplifyEnvironment;
    }
    get clientAIUrl() {
        return getDefaultClientAIStreamUrl(this.portalStore.amplifyEnvironment);
    }
    get clientAIContentUrl() {
        const org = this.portalStore.currentOrganization;
        if (org?.clientAIContentUrl) {
            return org.clientAIContentUrl;
        }
        return getDefaultClientAIContentUrl(this.portalStore.amplifyEnvironment);
    }
    get clientAIBaseUrl() {
        return this.portalStore.currentPortal?.clientAIBaseUrl ?? '';
    }
    getOrLoad(type, target) {
        return this.portalStore.getOrLoad(type, target);
    }
    createConversation(snapshot) {
        console.log('createConversation', snapshot);
        return this.conversationStore.createConversation(snapshot);
    }
    setCurrentConversation(newConversation) {
        return this.conversationStore.setCurrentConversation(newConversation);
    }
    get currentConversation() {
        return this.conversationStore.currentConversation;
    }
    get stylesheet() {
        return this.portalStore.currentPortal?.stylesheet;
    }
    get promptPlaceholder() {
        // This may be on portalStore or currentPortal
        // TODO: remove this MCN-2144 (move to tokens)
        return this.portalStore.currentPortal?.clientAIPromptPlaceholder ?? '';
    }
    get clientAIFeedbackButtons() {
        return this.portalStore.currentPortal?.clientAIFeedbackButtons ?? false;
    }
    get isAIServiceUnavailable() {
        return this.portalStore.currentOrganization?.isAIServiceUnavailable ?? false;
    }
    get clientAIConfig() {
        return this.portalStore.currentPortal?.clientAIConfig;
    }
    get clientAISuggestedPrompts() {
        // TODO: remove this MCN-2144 (move to tokens)
        return this.portalStore.currentPortal?.clientAISuggestedPrompts ?? [];
    }
    get clientAISuggestedPromptsLocalized() {
        return this.portalStore.currentPortal?.clientAIConfig?.clientAISuggestedPromptsLocalized
            ?? this.portalStore.currentPortal?.clientAISuggestedPromptsLocalized
            ?? false;
    }
    get clientAISuggestedPromptsL10N() {
        return this.portalStore.currentPortal?.clientAIConfig?.clientAISuggestedPromptsL10N
            ?? this.portalStore.currentPortal?.clientAISuggestedPromptsL10N;
    }
    get clientAIStartingMessage() {
        // TODO: remove this MCN-2144 (move to tokens)
        return this.portalStore.currentPortal?.clientAIStartingMessage ?? '';
    }
    get clientAIPersistentPrompts() {
        // TODO: remove this MCN-2144 (move to tokens)
        return this.portalStore.currentPortal?.clientAIPersistentPrompts ?? '';
    }
    get clientAIPersistentPromptsLocalized() {
        return this.portalStore.currentPortal?.clientAIConfig?.clientAIPersistentPromptsLocalized
            ?? this.portalStore.currentPortal?.clientAIPersistentPromptsLocalized
            ?? false;
    }
    get clientAIPersistentPromptsL10N() {
        return this.portalStore.currentPortal?.clientAIConfig?.clientAIPersistentPromptsL10N
            ?? this.portalStore.currentPortal?.clientAIPersistentPromptsL10N;
    }
    appendCustomerContext(data) {
        this.conversationStore.appendCustomerContext(data);
    }
    get customerContext() {
        return this.portalStore.customerContext;
    }
    get currentUser() {
        return this.portalStore.currentUser;
    }
    get widgetProps() {
        return this.portalStore.currentPortal?.widgetProps ?? {};
    }
    get suggestedPrompts() {
        return this.conversationStore.suggestedPrompts ?? [];
    }
    get smartSummary() {
        return this.conversationStore.smartSummary ?? null;
    }
    get suggestedPromptsHeader() {
        const portal = this.portalStore.currentPortal;
        return this.tokens.resolvePortalText(portal?.clientAIConfig?.pageSuggestedPromptsHeader, 'pageSuggestedPromptsHeader') || this.tokens.resolvePortalText(null, 'productPromptHeader');
    }
    get isLoadingSuggestedPrompts() {
        return this.conversationStore.isLoadingSuggestedPrompts ?? false;
    }
    get lastSuggestedPromptsKey() {
        return this.conversationStore.lastSuggestedPromptsKey ?? '';
    }
    requestPageSpecificPrompts(location) {
        return this.conversationStore.requestPageSpecificPrompts(location);
    }
    requestPageAdditionalData(location) {
        return this.conversationStore.requestPageAdditionalData(location);
    }
    setSuggestedPrompts(prompts) {
        this.conversationStore.setSuggestedPrompts(prompts);
    }
    setSmartSummary(summary) {
        this.conversationStore.setSmartSummary(summary);
    }
    get tokens() {
        const tokens = new Tokens(this.portalStore.currentPortal);
        const locale = this.portalStore.customerContext?.currentPage?.locale
            || this.portalStore.customerContext?.locale;
        if (locale) {
            tokens.setLocale(locale);
        }
        return tokens;
    }
    get defaultLocale() {
        return this.portalStore.currentPortal?.defaultLocale ?? 'en';
    }
}
//# sourceMappingURL=ConversationStoreAdapter.js.map